import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import BootstrapVue from "bootstrap-vue";
import "./styles/styles.scss";
Vue.use(BootstrapVue);
Vue.use(require("vue-moment"));

// import VueNestable from 'vue-nestable'
// Vue.use(VueNestable)
import "./views/layout/mixin/Global.js";

import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(fas);

Vue.component("font-awesome-icon", FontAwesomeIcon);

// import underscore from 'vue-underscore';
// Vue.use(underscore);

//import VueLodash from 'vue-lodash';
//import { lodash } from 'lodash';
//Vue.use(VueLodash,  { name: '_' , lodash: { map, random } })
/* Amplify setup */

import Amplify from "@aws-amplify/core";

/* setup userpool acc manual*/
import "./aws-custom-exports.js";

import "./attribute.js";

/* setup userpool acc from cli*/
// import awsconfig from './aws-custom-exports'
// Amplify.configure(awsconfig)

Vue.prototype.$Amplify = Amplify; // <- This line is important
Vue.use(Amplify);

/* interceptor setup */
import "./interceptor.js";

/* axios set up */
import axios from "axios";
axios.defaults.baseURL = process.env.VUE_APP_GATEWAY;
Vue.prototype.$axios = axios;

axios.defaults.headers.get["Content-Type"] =
	"application/x-www-form-urlencoded";
axios.defaults.headers.post["Content-Type"] = "multipart/form-data";

import * as VueSpinnersCss from "vue-spinners-css";
Vue.use(VueSpinnersCss);

import "./styles/custom-bootstrap.scss";

import VueClipboard from "vue-clipboard2";
VueClipboard.config.autoSetContainer = true; // add this line
Vue.use(VueClipboard);

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount("#app");
